export const getMessageLockedByTier = (tier) => {
    return `You must reach ${tier - 1} tier to continue`;
};
